import { render } from "./GlobalMenuTop.vue?vue&type=template&id=fb346d70"
import script from "./GlobalMenuTop.vue?vue&type=script&lang=js"
export * from "./GlobalMenuTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__